<div class="backdrop" fxLayoutAlign="center center">
  <div class="modal-wrapper" (click)="$event.stopPropagation()">
    <h3>{{ 'ibSpecific.payments.sign_payment_order_title' | translate }}</h3>

    <div class="textarea-form-field mb-24" fxLayoutAlign="space-between center">
      <p>
        {{ 'ibSpecific.payments.sign_payment_order' | translate }}
      </p>
      {{ alreadySigned && modalContent ? modalContent.content : '' }}
    </div>
    <div class="loader" *ngIf="loading"></div>
  </div>
</div>
